var checkboxSelectAll = {

	/**
	 * Init
	 *
	 * @param {object} target
	 * @returns {void}
	 */
	init: function(target) {

		target.querySelector('[data-checkbox-select-all]')?.addEventListener('click', function() {
			document.querySelectorAll(this.getAttribute('data-checkbox-select-all') + ' input[type="checkbox"]').forEach(function(checkbox) {
				checkbox.checked = !checkbox.checked;
			});
		});

	}

};

export default checkboxSelectAll;
